import {lazy} from "../../lib/lazy.js";
export const productBlibliRoutes = [
  {
    path: "/product-blibli",
    component: lazy(() => import(/* webpackChunkName: "productBlibliRoutes" */ "../../views/product-blibli/list/index.js")),
    auth: "list-product"
  },
  {
    path: "/product-blibli/add",
    component: lazy(() => import(/* webpackChunkName: "productBlibliRoutes" */ "../../views/productBlibli/product-blibli/add.js")),
    auth: "list-product"
  },
  {
    path: "/product-blibli/edit/:id",
    component: lazy(() => import(/* webpackChunkName: "productBlibliRoutes" */ "../../views/productBlibli/product-blibli/edit.js")),
    auth: "list-product"
  },
  {
    path: "/product-blibli/mass-category",
    component: lazy(() => import(/* webpackChunkName: "productBlibliRoutes" */ "../../views/productBlibli/product-blibli-category/index.js"))
  },
  {
    path: "/product-blibli/mass-attribute",
    component: lazy(() => import(/* webpackChunkName: "productBlibliRoutes" */ "../../views/productBlibli/product-blibli-attribute/index.js"))
  },
  {
    path: "/product-blibli/mass-edit",
    component: lazy(() => import(/* webpackChunkName: "productBlibliRoutes" */ "../../views/productBlibli/product-blibli-edit/batch-update.js")),
    auth: "list-product"
  }
];
